import {
    CHANGE_CONFIG_FILTRO_ENTITY,
    CHANGE_FILTRO_ENTITIES_SELECCIONADO,
    RESET_FILTRO_ENTITIES,
    SAVE_MUNICIPIOS,
    SAVE_PROVINCIAS
} from "../actions/actionsFilterEntities";
import {ERROR_GET_ENTITIES_BY_FILTER} from "../actions/actionsEntities";
import _ from "lodash"

const initial_filtroEntitySeleccionado = {
    tipo: ["protectora"],
    subtipo: [],
    geo: {
        provincia: undefined,
        municipio: undefined,
        near: false,
        userLocation: {
            useUserLocation: undefined,
            lat: undefined,
            lng: undefined,
            maxDistance: undefined
        },
        geoInBounds: {}
        
    }
};

const initialState = {
    
    
    filtroEntitySeleccionado: initial_filtroEntitySeleccionado,
    
    errorFiltro: undefined,
    
    config: {
        elementsPerPage: 30,
        elementsPerRow: 1,
        showListing: true,
        showMap: true,
        mobileMode: true,
        pagNum: 0
    },
    
    params: {
        provincias: [],
        municipios:{}
    }
};

export function reducerFilterEntity(state = _.cloneDeep(initialState), action) {
    switch (action.type) {
        case CHANGE_FILTRO_ENTITIES_SELECCIONADO:
            return {...state, filtroEntitySeleccionado: action.payload.filtroEntitySeleccionado};
        
        case CHANGE_CONFIG_FILTRO_ENTITY:
            return {...state, config: action.payload.config};
        
        
        case ERROR_GET_ENTITIES_BY_FILTER:
            return Object.assign({}, state, {
                errorFiltro: action.payload,
            });
        
        case SAVE_PROVINCIAS:
            return Object.assign({}, state, {
                params: {
                    provincias: action.payload.provincias,
                }
            });
        
        case SAVE_MUNICIPIOS:
            const municipios = state.params.municipios || {}
            municipios[action.payload.provincia] = action.payload.municipios
            return Object.assign({}, state, {
                params: {...state.params,
                    municipios: municipios
                }
            });
        
        case RESET_FILTRO_ENTITIES:
            return Object.assign({}, state, {
                filtroEntitySeleccionado: initial_filtroEntitySeleccionado
            });
        
        default:
            return state
    }
}